import { useContext } from 'react';

import { LeadContext } from './lead-context';

export const useLeadContext = () => useContext(LeadContext);
